$component-class: 'sn-hero-header-type-1';

.#{$component-class} {
  .me-heading {
    @include desktop {
      margin-top: map-get($map: $spacings, $key: 4xl);
    }
  }

  @include below($breakpoint-desktop-md) {
    me-column:first-child {
      text-align: center;
    }

    .me-list.me-list--inline.me-list--icon {
      justify-content: center;
    }

    .hero-header-type-1__actions-group {
      justify-content: center;
    }
  }

  // When media is visible (above 960px): keep input and button on one line
  @include above($breakpoint-desktop-md) {
    .form-free-trial-type-1__row {
      flex-wrap: nowrap;
    }

    .form-free-trial-type-1__cell:not(.form-free-trial-type-1__cell--submit) {
      flex: 0 0 280px;
    }

    .form-free-trial-type-1 input {
      min-width: 0;
      width: 280px;
    }
  }

  .sn-hero-header-type-1__media {
    width: 100%;
    aspect-ratio: 1.2;

    .picture {
      overflow: visible;

      img {
        width: auto;
      }
    }

    @include above($media-desktop) {
      margin-top: -#{map-get($map: $spacings, $key: 4xl)};
      margin-right: -#{map-get($map: $spacings, $key: 4xl)};
      margin-left: auto;
    }

    @include below($breakpoint-desktop-md) {
      display: none;
    }
  }

  [data-color-mode='signnow'] {
    sn-hero-header-type-1 {
      .me-list__item svg {
        fill: $color-system-success;
      }
    }
  }
}
